import EntityService from "../../MDF/Services/EntityService";

export default class UserDetailsService {
  getMyUserDetails = () => {
    return new EntityService().getDefinitionData('MY_USER_DETAILS_SERVICE_ENTITY');
  };
}